import { createFileRoute } from "@tanstack/react-router";
import Layout from "@/components/layout/Layout";
import CarmaxBrands from "@/components/carmax/CarmaxBrands";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/shop-by-brand")({
  head: () => ({
    ...pageHead({
      title: "Shop RVs by Brand",
      description: "Explore East to West, Forest River, inTech, Palomino and Sunseeker at Rex & Sons RVs in Castle Hayne, NC. Browse brand information and current RV inventory.",
      path: "/shop-by-brand",
    }),
    scripts: [{
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://www.rexandsonsrvs.com/" },
          { "@type": "ListItem", position: 2, name: "Shop by Brand", item: "https://www.rexandsonsrvs.com/shop-by-brand" },
        ],
      }),
    }],
  }),
  component: ShopByBrand,
});

function ShopByBrand() {
  return <Layout><CarmaxBrands detailed /></Layout>;
}